// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';

const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';

// In local mode Firebase is not used — skip initialization entirely
if (isLocal) {
  console.log('⚠️  LOCAL MODE: Firebase auth bypassed');
}

// Environment-based Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate required environment variables (skipped in local mode)
if (!isLocal) {
  const requiredEnvVars = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID'
  ];

  const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
  if (missingVars.length > 0) {
    throw new Error(`Missing required Firebase environment variables: ${missingVars.join(', ')}`);
  }

  // Object.keys(process.env)
  //   .filter(key => key.startsWith('REACT_APP'))
  //   .forEach(key => console.log(key + ':', process.env[key]));

  console.log(`🔥 Firebase initialized for: ${process.env.REACT_APP_ENVIRONMENT || 'development'}`);
  // console.log(`🔥 Project ID: ${firebaseConfig.projectId}`);
}

// Initialize Firebase (skipped in local mode)
const app = isLocal ? null : initializeApp(firebaseConfig);

// Initialize Firebase Authentication (null in local mode — AuthContext bypasses Firebase)
export const auth = isLocal ? null : getAuth(app);
export default app;